import React, { createContext, useContext, useState } from 'react';

const translations = {
  ro: {
    // Navbar
    nav: {
      produse: 'Produse',
      industrii: 'Industrii',
      despre: 'Despre noi',
      contact: 'Contact',
      toateProdusele: 'Toate produsele',
      toateIndustriile: 'Toate industriile',
    },
    // Footer
    footer: {
      desc: 'Producător local de ambalaje cu peste 20 de ani experiență. Două fabrici proprii, mii de produse pentru industria alimentară și industrială.',
      produse: 'Produse',
      industrii: 'Industrii',
      copy: 'Toate drepturile rezervate.',
      certificari: 'Certificări',
      contact: 'Contact',
      protectia: 'Protecția Consumatorilor',
      faq: 'FAQ',
    },
    // Home
    home: {
      heroBadge: 'Producător local · 20+ ani experiență',
      heroTitle1: 'Ambalaje',
      heroTitle2: 'care',
      heroTitle3: 'protejează',
      heroTitle4: 'și conservă.',
      heroDesc: 'Peste 20 de ani de experiență în producția de ambalaje. Două fabrici proprii, mii de tipuri de pungi, filme și ambalaje flexibile pentru sectorul alimentar și industrial.',
      heroBtn1: 'Explorați produsele',
      heroBtn2: 'Contactați-ne',
      statsYears: 'Ani de experiență',
      statsFactories: 'Fabrici proprii',
      statsGroups: 'Grupe de produse',
      statsMarkets: 'Piețe europene',
      productsEyebrow: 'Gama de produse',
      productsTitle: 'Explorați gama noastră de produse',
      productsDesc: 'Mii de tipuri de pungi, filme și ambalaje flexibile, grupate în ~20 grupe de produse.',
      productsAll: 'Toate produsele →',
      offersEyebrow: 'Selecție curentă',
      offersTitle: 'Cele mai bune oferte',
      offersAll: 'Toate ofertele →',
      aboutEyebrow: 'Despre noi',
      aboutTitle1: 'Unul dintre cei mai mari producători locali',
      aboutTitle2: 'de ambalaje',
      aboutDesc1: 'Cu peste 20 de ani de experiență, producem în două fabrici proprii mii de tipuri de pungi, filme și ambalaje flexibile pentru sectorul alimentar și industrial.',
      aboutDesc2: 'Exportăm întreaga gamă în Grecia, Germania, Spania, Franța și Polonia.',
      aboutBtn: 'Aflați mai multe',
      aboutCard1: '2 fabrici proprii', aboutCard1sub: 'Producție internă',
      aboutCard2: '~20 grupe produse', aboutCard2sub: 'Gamă completă',
      aboutCard3: '6 piețe europene', aboutCard3sub: 'Export activ',
      aboutCard4: 'Sector alimentar', aboutCard4sub: 'Focus principal',
      aboutCard5: 'Industrie auto', aboutCard5sub: 'Sector industrial',
      aboutCard6: 'Calitate ISO', aboutCard6sub: 'Certificări int.',
      newsletterEyebrow: 'Newsletter',
      newsletterTitle: 'Nu ratați nicio ofertă',
      newsletterDesc: 'Informații despre produse noi și oferte speciale direct în inbox-ul dumneavoastră.',
      newsletterPlaceholder: 'Adresa de email',
      newsletterBtn: 'Abonare',
      floatTag1: 'Carne', floatTag2: 'Brânzeturi', floatTag3: 'Congelate', floatTag4: 'Panificație',
      floatCard1: 'Pungi Vid Netede', floatCard1sub: 'Carne & produse proaspete',
      floatCard2: 'Filme Flow-Pack', floatCard2sub: 'Panificație & cofetărie',
      floatCard3: 'Export European', floatCard3sub: '6 piețe internaționale',
      floatCard4: 'Caserole & Tăvițe', floatCard4sub: 'Ambalaje rigide premium',
      floatStat: 'Tipuri de produse',
      floatTagTop: 'Top vânzări',
      floatTagInt: 'Internațional',
    },
    // Produse
    produse: {
      eyebrow: 'Gama completă',
      title1: 'Toate',
      title2: 'produsele',
      title3: 'noastre',
      desc: 'Mii de tipuri de pungi, filme și ambalaje flexibile, grupate în aproximativ 20 de grupe de produse.',
      btn1: 'Solicitați ofertă',
      btn2: 'Pe industrii →',
      statGroups: 'Grupe de produse',
      statTypes: 'Tipuri de ambalaje',
      statYears: 'Ani experiență',
      statMarkets: 'Piețe europene',
      filterAll: 'Toate',
      filterFood: 'Alimentar',
      filterIndustrial: 'Industrial',
      filterEquip: 'Echipamente',
      countLabel: 'categorii disponibile',
      seeTypes: 'Vezi tipurile →',
      typesAvailable: 'Tipuri disponibile',
      variantsOf: 'Variantele de',
      noVariant: 'Nu găsiți varianta potrivită?',
      noVariantDesc: 'Producem și la comandă după specificațiile dumneavoastră.',
      ctaTitle: 'Nu găsiți ce căutați?',
      ctaDesc: 'Contactați-ne pentru o ofertă personalizată. Producem și la comandă în funcție de specificațiile dumneavoastră.',
      ctaBtn1: 'Contactați-ne',
      ctaBtn2: 'Despre noi',
      contactBtn: 'Contactați-ne',
      backBtn: '← Înapoi la produse',
      allBtn: 'Toate produsele',
      requestBtn: 'Solicitați ofertă',
      seeDetails: 'Vezi detalii →',
      available: 'Produs disponibil',
      specAvail: 'Disponibilitate', specAvailVal: 'Stoc permanent',
      specDelivery: 'Livrare', specDeliveryVal: '24–48h',
      specMin: 'Comandă minimă', specMinVal: 'La cerere',
      specCustom: 'Personalizare', specCustomVal: 'Disponibilă',
      closeBtn: 'Închide',
      colabEyebrow: 'Colaborare',
      typesCount: 'tipuri',
      breadHome: 'Acasă',
      comingSoon: 'Pagină în construcție',
      comingSoonDesc: 'Pagina detaliată pentru această categorie va fi disponibilă în curând. Contactați-ne pentru informații complete despre produse și prețuri.',
    },
    // Industrii
    industrii: {
      eyebrow: 'Sectoare deservite',
      title1: 'Toate',
      title2: 'industriile',
      title3: 'noastre',
      desc: 'Experiență și soluții specializate pentru toate sectoarele economice majore din industria alimentară și cea industrială.',
      btn1: 'Solicitați ofertă',
      btn2: 'Vezi produse →',
      statIndustries: 'Industrii deservite',
      statYears: 'Ani experiență',
      statTypes: 'Tipuri de ambalaje',
      statMarkets: 'Piețe europene',
      filterAll: 'Toate',
      filterFood: 'Alimentar',
      filterHoreca: 'HoReCa',
      filterIndustrial: 'Industrial',
      countLabel: 'industrii disponibile',
      seeSolutions: 'Vezi soluțiile →',
      solutionsAvailable: 'Soluții disponibile',
      solutionsFor: 'Soluții pentru',
      noSolution: 'Nu găsiți soluția potrivită?',
      noSolutionDesc: 'Oferim soluții personalizate pentru orice cerință specifică industriei dumneavoastră.',
      ctaTitle: 'Nu găsiți industria dvs.?',
      ctaDesc: 'Oferim soluții personalizate pentru orice sector. Contactați-ne pentru o consultație gratuită.',
      ctaBtn1: 'Contactați-ne',
      ctaBtn2: 'Despre noi',
      backBtn: '← Înapoi',
      allBtn: 'Toate industriile',
      requestBtn: 'Solicitați ofertă',
      seeDetails: 'Vezi detalii →',
      available: 'Soluție disponibilă',
      specAvail: 'Disponibilitate', specAvailVal: 'Stoc permanent',
      specDelivery: 'Livrare', specDeliveryVal: '24–48h',
      specMin: 'Comandă minimă', specMinVal: 'La cerere',
      specCustom: 'Personalizare', specCustomVal: 'Disponibilă',
      closeBtn: 'Închide',
      colabEyebrow: 'Colaborare',
      solutionsCount: 'soluții',
      breadHome: 'Acasă',
      comingSoon: 'Pagină în construcție',
      comingSoonDesc: 'Pagina detaliată pentru această industrie va fi disponibilă în curând. Contactați-ne pentru informații complete.',
    },
    // Despre
    despre: {
      breadHome: 'Acasă',
      title: 'Despre Vertrag Plus',
      subtitle: 'Unul dintre cei mai mari producători locali de ambalaje, cu peste 20 de ani de experiență și prezență pe 6 piețe europene.',
      statYears: 'Ani de experiență',
      statFactories: 'Fabrici proprii',
      statGroups: 'Grupe de produse',
      statMarkets: 'Piețe europene',
      storyEyebrow: 'Povestea noastră',
      storyTitle: 'Producție locală de calitate europeană',
      storyP1: 'Cu peste 20 de ani de experiență în producția de ambalaje, Vertrag Plus produce în cele două fabrici proprii și comercializează mii de tipuri de pungi, filme și ambalaje flexibile, grupate în aproximativ 20 de grupe de produse.',
      storyP2: 'Produsele sunt destinate în principal sectorului alimentar, dar și operatorilor din domeniile tehnologic și industrial, cum ar fi industria auto.',
      storyP3: 'Pe lângă piața locală, exportăm întreaga gamă de ambalaje pe piețele din Grecia, Germania, Spania, Franța și Polonia.',
      fact1: '2 Fabrici proprii', fact1sub: 'Producție internă controlată',
      fact2: 'Mii de produse', fact2sub: '~20 grupe de produse',
      fact3: 'Sector alimentar', fact3sub: 'Focus principal',
      fact4: 'Industrie auto', fact4sub: 'Sector secundar',
      marketsEyebrow: 'Prezență internațională',
      marketsTitle: 'Piețe de desfacere',
      marketsSubtitle: 'Exportăm întreaga gamă de ambalaje pe piețele europene cheie.',
      marketMain: 'Piața principală',
      marketExport: 'Export activ',
      certsEyebrow: 'Calitate garantată',
      certsTitle: 'Certificări',
      certsSubtitle: 'Standarde internaționale care garantează calitatea și siguranța produselor noastre.',
      contactEyebrow: 'Luați legătura',
      contactTitle: 'Contact',
      contactDesc: 'Suntem disponibili de Luni până Vineri, între orele 08:00 – 17:00. Nu ezitați să ne contactați pentru orice întrebare legată de produsele sau serviciile noastre.',
      formTitle: 'Trimiteți un mesaj',
      formName: 'Nume complet',
      formEmail: 'Adresa de email',
      formCompany: 'Companie (opțional)',
      formMessage: 'Mesajul dumneavoastră...',
      formBtn: 'Trimite mesajul →',
    },
    // TopProduse
    topProduse: {
      eyebrow: 'Selecție curentă',
      title: 'Cele mai solicitate produse',
      allBtn: 'Vezi toate produsele →',
    },
  },

  en: {
    nav: {
      produse: 'Products',
      industrii: 'Industries',
      despre: 'About us',
      contact: 'Contact',
      toateProdusele: 'All products',
      toateIndustriile: 'All industries',
    },
    footer: {
      desc: 'Local packaging manufacturer with over 20 years of experience. Two own factories, thousands of products for the food and industrial sectors.',
      produse: 'Products',
      industrii: 'Industries',
      copy: 'All rights reserved.',
      certificari: 'Certifications',
      contact: 'Contact',
      protectia: 'Consumer Protection',
      faq: 'FAQ',
    },
    home: {
      heroBadge: 'Local manufacturer · 20+ years experience',
      heroTitle1: 'Packaging',
      heroTitle2: 'that',
      heroTitle3: 'protects',
      heroTitle4: 'and preserves.',
      heroDesc: 'Over 20 years of experience in packaging production. Two own factories, thousands of types of bags, films and flexible packaging for the food and industrial sectors.',
      heroBtn1: 'Explore products',
      heroBtn2: 'Contact us',
      statsYears: 'Years of experience',
      statsFactories: 'Own factories',
      statsGroups: 'Product groups',
      statsMarkets: 'European markets',
      productsEyebrow: 'Product range',
      productsTitle: 'Explore our product range',
      productsDesc: 'Thousands of types of bags, films and flexible packaging, grouped into ~20 product groups.',
      productsAll: 'All products →',
      offersEyebrow: 'Current selection',
      offersTitle: 'Best offers',
      offersAll: 'All offers →',
      aboutEyebrow: 'About us',
      aboutTitle1: 'One of the largest local',
      aboutTitle2: 'packaging manufacturers',
      aboutDesc1: 'With over 20 years of experience, we produce thousands of types of bags, films and flexible packaging for the food and industrial sectors in two own factories.',
      aboutDesc2: 'We export the entire range to Greece, Germany, Spain, France and Poland.',
      aboutBtn: 'Learn more',
      aboutCard1: '2 own factories', aboutCard1sub: 'Internal production',
      aboutCard2: '~20 product groups', aboutCard2sub: 'Complete range',
      aboutCard3: '6 European markets', aboutCard3sub: 'Active export',
      aboutCard4: 'Food sector', aboutCard4sub: 'Main focus',
      aboutCard5: 'Auto industry', aboutCard5sub: 'Industrial sector',
      aboutCard6: 'ISO quality', aboutCard6sub: 'Int. certifications',
      newsletterEyebrow: 'Newsletter',
      newsletterTitle: "Don't miss any offer",
      newsletterDesc: 'Information about new products and special offers directly in your inbox.',
      newsletterPlaceholder: 'Email address',
      newsletterBtn: 'Subscribe',
      floatTag1: 'Meat', floatTag2: 'Cheese', floatTag3: 'Frozen', floatTag4: 'Bakery',
      floatCard1: 'Smooth Vacuum Bags', floatCard1sub: 'Meat & fresh products',
      floatCard2: 'Flow-Pack Films', floatCard2sub: 'Bakery & confectionery',
      floatCard3: 'European Export', floatCard3sub: '6 international markets',
      floatCard4: 'Trays & Containers', floatCard4sub: 'Premium rigid packaging',
      floatStat: 'Product types',
      floatTagTop: 'Top sales',
      floatTagInt: 'International',
    },
    produse: {
      eyebrow: 'Full range',
      title1: 'All',
      title2: 'our',
      title3: 'products',
      desc: 'Thousands of types of bags, films and flexible packaging, grouped into approximately 20 product groups.',
      btn1: 'Request a quote',
      btn2: 'By industry →',
      statGroups: 'Product groups',
      statTypes: 'Packaging types',
      statYears: 'Years experience',
      statMarkets: 'European markets',
      filterAll: 'All',
      filterFood: 'Food',
      filterIndustrial: 'Industrial',
      filterEquip: 'Equipment',
      countLabel: 'categories available',
      seeTypes: 'See types →',
      typesAvailable: 'Available types',
      variantsOf: 'Variants of',
      noVariant: "Can't find the right variant?",
      noVariantDesc: 'We also produce to order according to your specifications.',
      ctaTitle: "Can't find what you're looking for?",
      ctaDesc: 'Contact us for a personalized quote. We also produce to order according to your specifications.',
      ctaBtn1: 'Contact us',
      ctaBtn2: 'About us',
      contactBtn: 'Contact us',
      backBtn: '← Back to products',
      allBtn: 'All products',
      requestBtn: 'Request a quote',
      seeDetails: 'See details →',
      available: 'Product available',
      specAvail: 'Availability', specAvailVal: 'Permanent stock',
      specDelivery: 'Delivery', specDeliveryVal: '24–48h',
      specMin: 'Minimum order', specMinVal: 'On request',
      specCustom: 'Customization', specCustomVal: 'Available',
      closeBtn: 'Close',
      colabEyebrow: 'Collaboration',
      typesCount: 'types',
      breadHome: 'Home',
      comingSoon: 'Page under construction',
      comingSoonDesc: 'The detailed page for this category will be available soon. Contact us for complete product and pricing information.',
    },
    industrii: {
      eyebrow: 'Sectors served',
      title1: 'All',
      title2: 'our',
      title3: 'industries',
      desc: 'Experience and specialized solutions for all major economic sectors in the food and industrial industries.',
      btn1: 'Request a quote',
      btn2: 'See products →',
      statIndustries: 'Industries served',
      statYears: 'Years experience',
      statTypes: 'Packaging types',
      statMarkets: 'European markets',
      filterAll: 'All',
      filterFood: 'Food',
      filterHoreca: 'HoReCa',
      filterIndustrial: 'Industrial',
      countLabel: 'industries available',
      seeSolutions: 'See solutions →',
      solutionsAvailable: 'Available solutions',
      solutionsFor: 'Solutions for',
      noSolution: "Can't find the right solution?",
      noSolutionDesc: 'We offer personalized solutions for any specific requirement of your industry.',
      ctaTitle: "Can't find your industry?",
      ctaDesc: 'We offer customized solutions for any sector. Contact us for a free consultation.',
      ctaBtn1: 'Contact us',
      ctaBtn2: 'About us',
      backBtn: '← Back',
      allBtn: 'All industries',
      requestBtn: 'Request a quote',
      seeDetails: 'See details →',
      available: 'Solution available',
      specAvail: 'Availability', specAvailVal: 'Permanent stock',
      specDelivery: 'Delivery', specDeliveryVal: '24–48h',
      specMin: 'Minimum order', specMinVal: 'On request',
      specCustom: 'Customization', specCustomVal: 'Available',
      closeBtn: 'Close',
      colabEyebrow: 'Collaboration',
      solutionsCount: 'solutions',
      breadHome: 'Home',
      comingSoon: 'Page under construction',
      comingSoonDesc: 'The detailed page for this industry will be available soon. Contact us for complete information.',
    },
    despre: {
      breadHome: 'Home',
      title: 'About Vertrag Plus',
      subtitle: 'One of the largest local packaging manufacturers, with over 20 years of experience and presence in 6 European markets.',
      statYears: 'Years of experience',
      statFactories: 'Own factories',
      statGroups: 'Product groups',
      statMarkets: 'European markets',
      storyEyebrow: 'Our story',
      storyTitle: 'Local production of European quality',
      storyP1: 'With over 20 years of experience in packaging production, Vertrag Plus produces in its two own factories and markets thousands of types of bags, films and flexible packaging, grouped into approximately 20 product groups.',
      storyP2: 'Products are mainly intended for the food sector, but also for operators in the technological and industrial fields, such as the automotive industry.',
      storyP3: 'In addition to the local market, we export the entire range of packaging to markets in Greece, Germany, Spain, France and Poland.',
      fact1: '2 Own factories', fact1sub: 'Controlled internal production',
      fact2: 'Thousands of products', fact2sub: '~20 product groups',
      fact3: 'Food sector', fact3sub: 'Main focus',
      fact4: 'Auto industry', fact4sub: 'Secondary sector',
      marketsEyebrow: 'International presence',
      marketsTitle: 'Sales markets',
      marketsSubtitle: 'We export the entire range of packaging to key European markets.',
      marketMain: 'Main market',
      marketExport: 'Active export',
      certsEyebrow: 'Guaranteed quality',
      certsTitle: 'Certifications',
      certsSubtitle: 'International standards that guarantee the quality and safety of our products.',
      contactEyebrow: 'Get in touch',
      contactTitle: 'Contact',
      contactDesc: 'We are available Monday to Friday, between 08:00 – 17:00. Do not hesitate to contact us for any question related to our products or services.',
      formTitle: 'Send a message',
      formName: 'Full name',
      formEmail: 'Email address',
      formCompany: 'Company (optional)',
      formMessage: 'Your message...',
      formBtn: 'Send message →',
    },
    topProduse: {
      eyebrow: 'Current selection',
      title: 'Most requested products',
      allBtn: 'See all products →',
    },
  },

  ru: {
    nav: {
      produse: 'Продукция',
      industrii: 'Отрасли',
      despre: 'О нас',
      contact: 'Контакт',
      toateProdusele: 'Вся продукция',
      toateIndustriile: 'Все отрасли',
    },
    footer: {
      desc: 'Местный производитель упаковки с более чем 20-летним опытом. Два собственных завода, тысячи продуктов для пищевой и промышленной отраслей.',
      produse: 'Продукция',
      industrii: 'Отрасли',
      copy: 'Все права защищены.',
      certificari: 'Сертификаты',
      contact: 'Контакт',
      protectia: 'Защита потребителей',
      faq: 'FAQ',
    },
    home: {
      heroBadge: 'Местный производитель · 20+ лет опыта',
      heroTitle1: 'Упаковка',
      heroTitle2: 'которая',
      heroTitle3: 'защищает',
      heroTitle4: 'и сохраняет.',
      heroDesc: 'Более 20 лет опыта в производстве упаковки. Два собственных завода, тысячи видов пакетов, пленок и гибкой упаковки для пищевой и промышленной отраслей.',
      heroBtn1: 'Смотреть продукцию',
      heroBtn2: 'Связаться',
      statsYears: 'Лет опыта',
      statsFactories: 'Собственных завода',
      statsGroups: 'Групп продуктов',
      statsMarkets: 'Европейских рынков',
      productsEyebrow: 'Ассортимент',
      productsTitle: 'Изучите наш ассортимент',
      productsDesc: 'Тысячи видов пакетов, пленок и гибкой упаковки, сгруппированных в ~20 групп продуктов.',
      productsAll: 'Вся продукция →',
      offersEyebrow: 'Текущий выбор',
      offersTitle: 'Лучшие предложения',
      offersAll: 'Все предложения →',
      aboutEyebrow: 'О нас',
      aboutTitle1: 'Один из крупнейших местных',
      aboutTitle2: 'производителей упаковки',
      aboutDesc1: 'Более 20 лет опыта в производстве упаковки. Производим тысячи видов пакетов, пленок и гибкой упаковки для пищевой и промышленной отраслей на двух собственных заводах.',
      aboutDesc2: 'Экспортируем весь ассортимент в Грецию, Германию, Испанию, Францию и Польшу.',
      aboutBtn: 'Узнать больше',
      aboutCard1: '2 завода', aboutCard1sub: 'Внутреннее производство',
      aboutCard2: '~20 групп продуктов', aboutCard2sub: 'Полный ассортимент',
      aboutCard3: '6 европейских рынков', aboutCard3sub: 'Активный экспорт',
      aboutCard4: 'Пищевой сектор', aboutCard4sub: 'Основной фокус',
      aboutCard5: 'Автопромышленность', aboutCard5sub: 'Промышленный сектор',
      aboutCard6: 'Качество ISO', aboutCard6sub: 'Международные сертификаты',
      newsletterEyebrow: 'Рассылка',
      newsletterTitle: 'Не пропустите ни одного предложения',
      newsletterDesc: 'Информация о новых продуктах и специальных предложениях прямо в вашем почтовом ящике.',
      newsletterPlaceholder: 'Адрес электронной почты',
      newsletterBtn: 'Подписаться',
      floatTag1: 'Мясо', floatTag2: 'Сыры', floatTag3: 'Заморозка', floatTag4: 'Выпечка',
      floatCard1: 'Гладкие вакуумные пакеты', floatCard1sub: 'Мясо и свежие продукты',
      floatCard2: 'Пленки Flow-Pack', floatCard2sub: 'Выпечка и кондитерские изделия',
      floatCard3: 'Европейский экспорт', floatCard3sub: '6 международных рынков',
      floatCard4: 'Лотки и контейнеры', floatCard4sub: 'Премиум жёсткая упаковка',
      floatStat: 'Видов продуктов',
      floatTagTop: 'Топ продаж',
      floatTagInt: 'Международный',
    },
    produse: {
      eyebrow: 'Полный ассортимент',
      title1: 'Вся',
      title2: 'наша',
      title3: 'продукция',
      desc: 'Тысячи видов пакетов, пленок и гибкой упаковки, сгруппированных приблизительно в 20 групп продуктов.',
      btn1: 'Запросить предложение',
      btn2: 'По отраслям →',
      statGroups: 'Групп продуктов',
      statTypes: 'Видов упаковки',
      statYears: 'Лет опыта',
      statMarkets: 'Европейских рынков',
      filterAll: 'Все',
      filterFood: 'Пищевые',
      filterIndustrial: 'Промышленные',
      filterEquip: 'Оборудование',
      countLabel: 'категорий доступно',
      seeTypes: 'Смотреть виды →',
      typesAvailable: 'Доступные виды',
      variantsOf: 'Варианты',
      noVariant: 'Не нашли подходящий вариант?',
      noVariantDesc: 'Производим также на заказ по вашим спецификациям.',
      ctaTitle: 'Не нашли то, что ищете?',
      ctaDesc: 'Свяжитесь с нами для персонального предложения. Производим также на заказ по вашим спецификациям.',
      ctaBtn1: 'Связаться',
      ctaBtn2: 'О нас',
      contactBtn: 'Связаться',
      backBtn: '← Назад к продукции',
      allBtn: 'Вся продукция',
      requestBtn: 'Запросить предложение',
      seeDetails: 'Подробнее →',
      available: 'Продукт доступен',
      specAvail: 'Наличие', specAvailVal: 'Постоянный склад',
      specDelivery: 'Доставка', specDeliveryVal: '24–48 ч',
      specMin: 'Минимальный заказ', specMinVal: 'По запросу',
      specCustom: 'Персонализация', specCustomVal: 'Доступна',
      closeBtn: 'Закрыть',
      colabEyebrow: 'Сотрудничество',
      typesCount: 'видов',
      breadHome: 'Главная',
      comingSoon: 'Страница в разработке',
      comingSoonDesc: 'Подробная страница для этой категории скоро будет доступна. Свяжитесь с нами для получения полной информации о продуктах и ценах.',
    },
    industrii: {
      eyebrow: 'Обслуживаемые отрасли',
      title1: 'Все',
      title2: 'наши',
      title3: 'отрасли',
      desc: 'Опыт и специализированные решения для всех основных экономических секторов в пищевой и промышленной отраслях.',
      btn1: 'Запросить предложение',
      btn2: 'Смотреть продукцию →',
      statIndustries: 'Обслуживаемых отраслей',
      statYears: 'Лет опыта',
      statTypes: 'Видов упаковки',
      statMarkets: 'Европейских рынков',
      filterAll: 'Все',
      filterFood: 'Пищевые',
      filterHoreca: 'HoReCa',
      filterIndustrial: 'Промышленные',
      countLabel: 'отраслей доступно',
      seeSolutions: 'Смотреть решения →',
      solutionsAvailable: 'Доступные решения',
      solutionsFor: 'Решения для',
      noSolution: 'Не нашли подходящее решение?',
      noSolutionDesc: 'Предлагаем персонализированные решения для любых специфических требований вашей отрасли.',
      ctaTitle: 'Не нашли вашу отрасль?',
      ctaDesc: 'Предлагаем индивидуальные решения для любого сектора. Свяжитесь с нами для бесплатной консультации.',
      ctaBtn1: 'Связаться',
      ctaBtn2: 'О нас',
      backBtn: '← Назад',
      allBtn: 'Все отрасли',
      requestBtn: 'Запросить предложение',
      seeDetails: 'Подробнее →',
      available: 'Решение доступно',
      specAvail: 'Наличие', specAvailVal: 'Постоянный склад',
      specDelivery: 'Доставка', specDeliveryVal: '24–48 ч',
      specMin: 'Минимальный заказ', specMinVal: 'По запросу',
      specCustom: 'Персонализация', specCustomVal: 'Доступна',
      closeBtn: 'Закрыть',
      colabEyebrow: 'Сотрудничество',
      solutionsCount: 'решений',
      breadHome: 'Главная',
      comingSoon: 'Страница в разработке',
      comingSoonDesc: 'Подробная страница для этой отрасли скоро будет доступна. Свяжитесь с нами для получения полной информации.',
    },
    despre: {
      breadHome: 'Главная',
      title: 'О Vertrag Plus',
      subtitle: 'Один из крупнейших местных производителей упаковки, с более чем 20-летним опытом и присутствием на 6 европейских рынках.',
      statYears: 'Лет опыта',
      statFactories: 'Собственных завода',
      statGroups: 'Групп продуктов',
      statMarkets: 'Европейских рынков',
      storyEyebrow: 'Наша история',
      storyTitle: 'Местное производство европейского качества',
      storyP1: 'С более чем 20-летним опытом в производстве упаковки, Vertrag Plus производит на двух собственных заводах и реализует тысячи видов пакетов, пленок и гибкой упаковки, сгруппированных приблизительно в 20 групп продуктов.',
      storyP2: 'Продукция предназначена главным образом для пищевого сектора, а также для операторов технологических и промышленных областей, таких как автомобильная промышленность.',
      storyP3: 'Помимо местного рынка, мы экспортируем весь ассортимент упаковки на рынки Греции, Германии, Испании, Франции и Польши.',
      fact1: '2 собственных завода', fact1sub: 'Контролируемое внутреннее производство',
      fact2: 'Тысячи продуктов', fact2sub: '~20 групп продуктов',
      fact3: 'Пищевой сектор', fact3sub: 'Основной фокус',
      fact4: 'Автопромышленность', fact4sub: 'Вторичный сектор',
      marketsEyebrow: 'Международное присутствие',
      marketsTitle: 'Рынки сбыта',
      marketsSubtitle: 'Экспортируем весь ассортимент упаковки на ключевые европейские рынки.',
      marketMain: 'Основной рынок',
      marketExport: 'Активный экспорт',
      certsEyebrow: 'Гарантированное качество',
      certsTitle: 'Сертификаты',
      certsSubtitle: 'Международные стандарты, гарантирующие качество и безопасность нашей продукции.',
      contactEyebrow: 'Свяжитесь с нами',
      contactTitle: 'Контакт',
      contactDesc: 'Мы доступны с понедельника по пятницу с 08:00 до 17:00. Не стесняйтесь обращаться к нам по любому вопросу, связанному с нашей продукцией или услугами.',
      formTitle: 'Отправить сообщение',
      formName: 'Полное имя',
      formEmail: 'Адрес электронной почты',
      formCompany: 'Компания (необязательно)',
      formMessage: 'Ваше сообщение...',
      formBtn: 'Отправить →',
    },
    topProduse: {
      eyebrow: 'Текущий выбор',
      title: 'Наиболее востребованные продукты',
      allBtn: 'Смотреть всю продукцию →',
    },
  },
};

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    return localStorage.getItem('vertrag_lang') || 'ro';
  });

  const switchLang = (l) => {
    setLang(l);
    localStorage.setItem('vertrag_lang', l);
  };

  const t = translations[lang];

  return (
    <LanguageContext.Provider value={{ lang, switchLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}